import React from 'react';
import { Box, Paper, Typography, Grid } from '@mui/material';
import { DemandItem } from './CalendarPlanner';

interface Props {
  demands: DemandItem[];
}

export const PlannerSummary = ({ demands }: Props) => {
  // Calcula estadísticas
  const demandsCreadas = demands.length;
  const fechasUnicas = new Set(demands.map((d) => d.dateStr)).size;
  const cargosUnicos = new Set(demands.map((d) => d.cargoId)).size;
  const turnosUnicos = new Set(demands.map((d) => d.turnoId)).size;
  // Agrupar por fecha y sumar la cantidad de empleados requeridos cada día
  const empleadosPorDia: Record<string, number> = {};
  demands.forEach((d) => {
    if (!empleadosPorDia[d.dateStr]) {
      empleadosPorDia[d.dateStr] = 0;
    }
    empleadosPorDia[d.dateStr] += Number(d.cantidad);
  });

  // El total de empleados requeridos es el máximo necesario en un solo día (pico de operación)
  const totalEmpleados =
    Object.values(empleadosPorDia).length > 0 ? Math.max(...Object.values(empleadosPorDia)) : 0;

  const StatCard = ({
    title,
    value,
    color,
  }: {
    title: string;
    value: string | number;
    color?: string;
  }) => (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: '1px solid #E0E3E7',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1, textAlign: 'center' }}>
        {title}
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 'bold', color: color || 'text.primary' }}>
        {value}
      </Typography>
    </Paper>
  );

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
        Panel Resumen
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
          <StatCard title="Demandas creadas" value={demandsCreadas} color="#696CFF" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
          <StatCard title="Días con demanda" value={fechasUnicas} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
          <StatCard title="Cargos involucrados" value={cargosUnicos} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
          <StatCard title="Turnos utilizados" value={turnosUnicos} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
          <StatCard title="Empleados requeridos" value={totalEmpleados} color="#71DD37" />
        </Grid>
      </Grid>
    </Box>
  );
};
